/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Col_Product_LotInputs */

const vi_confirm_return_col_product_lot = /** @type {(inputs: Confirm_Return_Col_Product_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm / Lô`)
};

/**

* @param {Confirm_Return_Col_Product_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_col_product_lot = /** @type {((inputs?: Confirm_Return_Col_Product_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Col_Product_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_col_product_lot(inputs)
});